<template>
	<!-- One curriculum's goals, read-only: the curriculum's own inline viewer when it has
	     one, our own list otherwise. Extracted so GoalsDisplay can render a group either
	     flat or inside an accordion section without duplicating the markup. -->
	<GoalPickerExternal
		v-if="group.curriculum.hasInlineGoalViewer()"
		mode="inline"
		:readonly="true"
		:curriculum="group.curriculum"
		:selectedGoals="group.goals"
		context="view"
	/>
	<ul v-else class="flex flex-col gap-2 mt-1">
		<li
			v-for="goal in rows"
			:key="goal.id || goal.sourceId || goal.fullPath"
			class="flex gap-2"
			:class="[
				goal.isSubgoal() ? 'pl-6 text-sm' : '',
				goal.isSubgoal() && goal.muted ? 'opacity-40' : '',
			]"
		>
			<MapPinIcon
				class="shrink-0"
				:class="[goal.isSubgoal() ? 'mt-1 w-3 h-3' : 'mt-0.5 w-4 h-4']"
				:style="{ color: goal.color ?? '#86efac' }"
			/>
			<span
				class="text-base-content-light mr-2 shrink-0 w-24 overflow-hidden whitespace-nowrap text-ellipsis"
				:title="goal.fullPath"
			>{{ goal.fullPath }}</span>
			<GoalTitle :goal="goal" titleClasses="whitespace-pre-wrap" />
		</li>
	</ul>
</template>

<script lang="ts">
import GoalTitle from "@/components/GoalTitle.vue";
import GoalPickerExternal from "@/components/GoalPickerExternal.vue";
import { MapPinIcon } from "@heroicons/vue/24/solid";
import { Goal } from "@/models/Goal.model";
import { groupSubgoalsUnderParents } from "@/goals/utils/SubgoalRows.util";

export default {

	components: {
		GoalTitle,
		GoalPickerExternal,
		MapPinIcon,
	},

	props: {
		group: {
			type: Object,
			required: true,
		},
	},

	computed: {
		rows(): Goal[] {
			return groupSubgoalsUnderParents(this.group.goals as Goal[]);
		},
	},

};
</script>
